<template>
  <v-dialog v-model="dialog" persistent width="800px" @keydown.esc="hide">
    <v-form>
      <v-card>
        <v-card-title class="card-panel blue lighten-3">Микроюнит #{{ form.uitemID }}</v-card-title>

        <v-container>
          <v-text-field v-model="form.unitName"
            autofocus
            persistent-hint
            disabled
            hint="Наименование юнита"
          />

          <v-row>
            <v-col class="pt-0">
              <v-text-field
                v-model="dateText"
                :reactive="false"
                hint="Месяц по плану"
                persistent-hint
                readonly
                style="max-width: 200px"/>
            </v-col>

            <v-col class="pt-0">
              <v-menu
                ref="menu"
                v-model="datePickerStart"
                :close-on-content-click="false"
                transition="scale-transition"
                max-width="460px"
                offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateTextStart"
                    :reactive="false"
                    hint="Начало размещения"
                    persistent-hint
                    readonly
                    clearable
                    @click:clear="form.uitemDateStart=''"
                    v-on="on"
                    style="max-width: 200px"/>
                </template>
                <v-date-picker
                  v-model="form.uitemDateStart"
                  landscape
                  scrollable
                  reactive
                  @input="datePickerStart=false"/>
              </v-menu>
            </v-col>

            <v-col class="pt-0">
              <v-menu
                ref="menu"
                v-model="datePickerStop"
                :close-on-content-click="false"
                transition="scale-transition"
                max-width="460px"
                offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateTextStop"
                    :reactive="false"
                    hint="Окончание размещения"
                    persistent-hint
                    readonly
                    clearable
                    @click:clear="form.uitemDateStop=''"
                    v-on="on"
                    style="max-width: 200px"/>
                </template>
                <v-date-picker
                  v-model="form.uitemDateStop"
                  landscape
                  scrollable
                  reactive
                  @input="datePickerStop=false"/>
              </v-menu>
            </v-col>
          </v-row>

          <div class="caption mt-5 grey--text text--darken-3">Дополнительная информация</div>
          <vue-editor v-model="form.uitemInfo" class="mt-1"/>
        </v-container>

        <v-card-actions>
          <v-btn raised @click="hide">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" raised color="primary" :disabled="$v.$invalid" :loading="loading" @click.prevent="submitAction">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import api from '@/api'
import { validationMixin } from 'vuelidate'
import { required, numeric, between } from 'vuelidate/lib/validators'
import { VueEditor } from "vue2-editor";

export default {
  components: { VueEditor },
  mixins: [ validationMixin ],
  data: () => ({
    dialog: false,
    loading: false,
    datePicker: false,
    datePickerStart: false,
    datePickerStop: false,
    form: {}
  }),
  validations: {
    form: {
      uitemYm: { required}
    }
  },
  computed: {
    verrUitemYm () { return this.$v.form.uitemYm.$invalid ? 'Выберите месяц размещения' : [] },
    dateText () {
      if ( this.form.uitemYm == '' ) return ''
      let date = new Date(this.form.uitemYm+'-01')
      return date.getFullYear()+' — '+date.toLocaleString('default', { month: 'long' })
    },
    dateTextStart () {
      if ( this.form.uitemDateStart == '' ) return ''
      let date = new Date(this.form.uitemDateStart)
      return date.toLocaleString('default', { year: 'numeric', month: 'long', day: 'numeric' })
    },
    dateTextStop () {
      if ( this.form.uitemDateStop == '' ) return ''
      let date = new Date(this.form.uitemDateStop)
      return date.toLocaleString('default', { year: 'numeric', month: 'long', day: 'numeric' })
    }
  },
  methods: {
    edit (data) {
      if ( typeof data.uitemID == 'undefined' ) return
      api.get('microunits/get/'+data.uitemID).then(response => {
        this.form = Object.assign({}, data, response.data.data.microunit)
        let s = String(this.form.uitemYm)
        this.form.uitemYm = s.substr(0, 4)+'-'+s.substr(4, 2)
        this.dialog = true
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    hide () {
      if ( this.datePicker || this.datePickerStart || this.datePickerStop ) return
      this.dialog = false
    },
    submitAction() {
      if ( this.$v.$invalid ) return
      this.loading = true
      api.post('microunits/update/'+this.form.uitemID, this.form).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return alert(response.data.data)
        this.hide()
        this.form = {}
        this.$emit('updated');
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  },
}
</script>
